import { Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

/** @deprecated - This component should not be used */
@Component({
    selector: 'sb-modal-footer',
    template: `
        <footer [ngClass]="alignActions" class="sb-modal-footer">
            <a
                [attr.data-cy]="'modal-left-close'"
                class="btn secondary me-3"
                [routerLink]="closeUrl"
                replaceUrl="true"
            >
                Close
            </a>
            <div class="mx-n2" style="flex: auto"></div>
            <ng-content></ng-content>
        </footer>
    `,
    styles: [],
    imports: [CommonModule, RouterLink],
    standalone: true
})
export class SbModalFooterComponent {
    get dialog(): boolean {
        return this._dialog;
    }

    get alignActions(): string {
        return this._alignActions;
    }

    @Input() set alignActions(value: string) {
        this._alignActions = value;
        switch (value) {
            case 'center':
                this._alignActions = 'justify-content-between';
                break;
            case 'left':
                this._alignActions = 'justify-content-start';
                break;
            case 'right':
                this._alignActions = 'justify-content-end';
                break;
            default:
                this._alignActions = 'justify-content-between';
                break;
        }
    }

    @Input() set dialog(value: boolean) {
        this._dialog = value;
        this.closeUrl =
            this.dialog === true
                ? ['', { outlets: { dialog: null } }]
                : ['', { outlets: { dialog: null, modal: null } }];
    }
    constructor() {}
    private _dialog: boolean;
    private _alignActions: string;
    closeUrl: Array<any> = ['', { outlets: { dialog: null } }];
}
